import { LegalH2, Li, Ol, Ul } from '@collab/atoms';

import PageSeo from 'libs/seo/PageSeo';

import InlineLink from './InlineLinkMd';
import LegalFooter from './LegalFooter';

export const legalComponents: any = {
  h2: LegalH2,
  li: Li,
  ol: Ol,
  ul: Ul,
  a: InlineLink,
  PageSeo,
  LegalFooter,
};
